import {
  OpportunityItemModel,
  StageItemModel
} from "./chunk-VOJ26Y2M.js";
import {
  CrmOpportunityRoute_default
} from "./chunk-WAYP3IW7.js";

// src/Crm/CrmOpportunity/CrmOpportunity.ts
import axios from "axios";
var AesirxCrmOpportunityApiService = class {
  constructor() {
    this.route = null;
    this.create = async (data) => {
      try {
        const dataToSubmit = false ? data : OpportunityItemModel.__transformItemToApiOfCreation(data);
        const result = await this.route.create(dataToSubmit);
        if (result) {
          return result;
        }
        return { message: "Something have problem" };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.update = async (data) => {
      try {
        const dataToSubmit = false ? data : OpportunityItemModel.__transformItemToApiOfUpdation(data);
        const result = await this.route.update(dataToSubmit);
        if (result) {
          return result;
        }
        return { message: "Something have problem" };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.getDetail = async (id = 0) => {
      try {
        const data = await this.route.getDetail(id);
        let results = null;
        if (data) {
          results = new OpportunityItemModel(data);
        }
        if (results) {
          results = results.toJSON();
        }
        return results;
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.getList = async (filter) => {
      try {
        const data = await this.route.getList(filter);
        let listItems = null;
        let pagination = null;
        if (data?._embedded) {
          listItems = await Promise.all(
            data._embedded.item.map(async (o) => {
              return new OpportunityItemModel(o);
            })
          );
        }
        pagination = {
          page: data.page,
          pageLimit: data.pageLimit,
          totalPages: data.totalPages,
          totalItems: data.totalItems,
          limitStart: data.limitstart
        };
        return {
          listItems: listItems ?? [],
          pagination: pagination ?? {}
        };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.updateStatus = async (arr, status) => {
      try {
        const result = await this.route.updateStatus(arr, status);
        if (result) {
          return result.result;
        }
        return { message: "Something have problem" };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.delete = async (ids) => {
      try {
        const result = await this.route.delete(ids);
        if (result) {
          return result.result;
        }
        return { message: "Something have problem" };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.getStageList = async () => {
      try {
        const data = await this.route.getStageList();
        let stageListItems = null;
        if (data?.result) {
          stageListItems = await Promise.all(
            data.result.map(async (o) => {
              return new StageItemModel(o);
            })
          );
        }
        return {
          stageListItems: stageListItems ?? []
        };
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.route = new CrmOpportunityRoute_default();
  }
};

export {
  AesirxCrmOpportunityApiService
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
